import { ClaimAction } from "./types";

export const updateClaimState = (payload) =>
  ({
    type: ClaimAction.UPDTAE_CLAIM_STATE,
    payload,
  }) as const;

export const uploadClaimImage = (payload) =>
  ({
    type: ClaimAction.UPLOAD_CLAIM_IMAGE,
    payload,
  }) as const;

export const removeClaimImage = (payload) =>
  ({
    type: ClaimAction.REMOVE_CLAIM_IMAGE,
    payload,
  }) as const;

export const cleanUpClaim = () =>
  ({
    type: ClaimAction.CLEAN_UP,
  }) as const;

export const submitClaim = () =>
  ({
    type: ClaimAction.SUBMIT_CLAIM,
  }) as const;

export const createClaim = (payload) =>
  ({
    type: ClaimAction.CREATE_CLAIM,
    payload,
  }) as const;

export const fetchClaim = (payload: string) =>
  ({
    type: ClaimAction.FETCH_CLAIM,
    payload,
  }) as const;
